<template>
  <div v-if="isDebugMode" class="define-location grid">
    <RoutingDetails
      title="DEFINE LOCATION"
      image="define-location"
      :queryParams="queryParams"
      :metaParams="metaParams"
      :path="path"
    />
    <RoutingNavigation
      :isPreviousAvailable="isPreviousAvailable"
      :isNextAvailable="isNextAvailable"
      @previous="previous()"
      @next="next()"
    />
  </div>
</template>
<script lang="ts">
import { defineComponent, onMounted, watch } from 'vue';

import { TRACKING_PAGE_NAME } from '@dh-io-otb/shared/src/models/constants';

import { useDebugger } from '../../composables/debugger.composable';
import { useRoutingApplication } from '../../composables/routing-application.composable';
import { useStore } from '@dh-io-otb/shared/src/composables/store.composable';

import TrackingService from '@dh-io-otb/shared/src/services/tracking.service';

import RoutingDetails from '../../components/routing-details/routing-details.vue';
import RoutingNavigation from '../../components/routing-navigation/routing-navigation.vue';

export default defineComponent({
  name: 'otb-define-location',
  components: {
    RoutingDetails,
    RoutingNavigation,
  },
  setup() {
    const { isDebugMode } = useDebugger();
    const {
      queryParams,
      metaParams,
      path,
      isPreviousAvailable,
      isNextAvailable,
      previous,
      selectLocation,
      onMountedActions,
    } = useRoutingApplication();

    const { state } = useStore();

    onMounted(onMountedActions);

    watch(
      () => state.otbcFlow.model.id,
      () => {
        TrackingService.trackPageView(TRACKING_PAGE_NAME.SEARCH);
      },
    );

    return {
      queryParams,
      metaParams,
      path,
      isPreviousAvailable,
      isNextAvailable,
      previous,
      next: selectLocation,
      isDebugMode,
    };
  },
});
</script>
<style scoped lang="scss" src="./define-location.scss"></style>
